// extracted by mini-css-extract-plugin
export default {"imgdiv":"ba2d663473 d29d8f4202","img":"fde5c152cc c93efec2d1"};